import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

import Loader from '../../components/Common/Loader';
import PlcSafetyEventList from '../../components/Lists/PlcSafetyEventList';
import { getPlcSafetyEvents } from '../../store/actions';

class PlcSafetyEvents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      eventList: null,
    };
  }

  componentDidMount() {
    this.props.getPlcSafetyEvents(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.events !== prevProps.events) {
      this.setState({ eventList: this.props.events });
    }
  }

  refresh(event) {
    event.preventDefault();
    this.setState({ eventList: null });
    this.props.getPlcSafetyEvents(this.state.user);
  }

  render() {
    if (!this.state.eventList) {
      return (
        <div className="loaderCenter">
          <Loader></Loader>
        </div>
      );
    }
    return (
      <div className="user-management">
        <Container fluid>
          <Button
            onClick={(event) => this.refresh(event)}
            color="primary"
            className="btn btn-primary buttonStatus usersButtons"
          >
            <i size="lg" className="mdi mdi-refresh"></i>
          </Button>
          <Button className="btn btn-primary waves-effect waves-light buttonStatus usersButtons">
            <Link to="/createPlcSafetyEvent">{this.props.t('Crear evento')}</Link>
          </Button>
          <Button className="btn btn-secondary waves-effect waves-light buttonStatus usersButtons">
            <Link to="/plcSafetyTriggers">{this.props.t('Ver triggers')}</Link>
          </Button>
          <PlcSafetyEventList eventList={this.state.eventList} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { events } = state.getPlcSafetyEvents;
  return { events };
};

export default withRouter(connect(mapStateToProps, { getPlcSafetyEvents })(withNamespaces()(PlcSafetyEvents)));
